import { Menu, Transition } from "@headlessui/react";
import { Link } from "react-router-dom";

/**
 * @param {ReactElement} children //Must provide your own styled button 
 * @param {[Object]} menuList //Menu list options 
*/
export default function Dropdown({ children, menuList, width, header }) {
    return (
        <div className="relative inline-block text-left z-50">
            <Menu>
                {({ open }) => (
                    <>
                        <span className="rounded-md shadow-sm">
                            <Menu.Button as="div">{children}</Menu.Button>
                        </span>

                        <Transition
                            show={open}
                            enter="transition ease-out duration-100"
                            enterFrom="transform opacity-0 scale-95"
                            enterTo="transform opacity-100 scale-100"
                            leave="transition ease-in duration-75"
                            leaveFrom="transform opacity-100 scale-100"
                            leaveTo="transform opacity-0 scale-95"
                        >
                            <Menu.Items
                                static
                                className={`absolute right-0 mt-2 origin-top-right bg-white border 
                                    border-gray-200 divide-y divide-gray-100 rounded-md shadow-lg
                                    outline-none ${width ?? "w-56"}`
                                }
                            >
                                {header}
                                <div className="py-1">
                                    {
                                        menuList.map(menu => {
                                            const { label, link, icon, callback, borderTop } = menu
                                            return (
                                                <Menu.Item key={label}>
                                                    {({ active }) => (
                                                        <Link
                                                            to={link ?? "#"}
                                                            onClick={callback && callback}
                                                            className={
                                                                `flex items-center px-4 py-2.5 text-sm leading-5 text-left space-x-3 
                                                                ${active ? "bg-gray-50" : "bg-white"} 
                                                                ${borderTop && "border-t border-gray-200"} `
                                                            }
                                                        >
                                                            {icon &&
                                                                <span className={`text-lg ${active ? "text-indigo-600" : "text-gray-700"}`}>{icon}</span>
                                                            }
                                                            <span className={active ? "text-indigo-600" : "text-gray-700"}>{label}</span>
                                                        </Link>
                                                    )}
                                                </Menu.Item>
                                            )
                                        })
                                    }
                                </div>
                            </Menu.Items>
                        </Transition>
                    </>
                )}
            </Menu>
        </div>
    );
}
